import { render } from "./ModalEditAddressBill.vue?vue&type=template&id=45b980d4"
import script from "./ModalEditAddressBill.vue?vue&type=script&lang=js"
export * from "./ModalEditAddressBill.vue?vue&type=script&lang=js"

import exportComponent from "/var/srv/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__